import React from 'react';
import { Code, Heart, Sparkles } from 'lucide-react';

const Home = () => {
  return (
    <div className="pt-24 pb-12 px-4 sm:px-6 lg:px-8 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        {/* Hero Section */}
        <div className="text-center mb-16">
          <div className="mondrian-card p-12 mb-8 relative overflow-hidden">
            <div className="absolute top-0 left-0 h-full accent-bar-red"></div>
            <h1 className="text-5xl md:text-7xl font-bold mb-6 text-black">
              Hi, I'm Blake
            </h1>
            <p className="text-xl md:text-2xl text-gray-700 mb-8 leading-relaxed max-w-3xl mx-auto">
              I'm building things that I think are interesting and likely to make the world feel a little more connected. My work is informed by my time as a teacher, cyber intel officer in the USN, and edtech founder.
            </p>
            <div className="flex flex-wrap justify-center gap-4 text-black">
              <div className="flex items-center gap-2 bg-[#E53935] text-white px-5 py-3 font-bold border-2 border-black">
                <Code className="w-5 h-5" />
                <span>Full Stack Claude Coder</span>
              </div>
              <div className="flex items-center gap-2 bg-[#1E88E5] text-white px-5 py-3 font-bold border-2 border-black">
                <Heart className="w-5 h-5" />
                <span>Problem Solver</span>
              </div>
              <div className="flex items-center gap-2 bg-[#FBC02D] text-black px-5 py-3 font-bold border-2 border-black">
                <Sparkles className="w-5 h-5" />
                <span>Creative Thinker</span>
              </div>
            </div>
          </div>
        </div>

        {/* About Preview */}
        <div className="mondrian-card p-8 text-center relative overflow-hidden">
          <div className="absolute top-0 right-0 h-full accent-bar-blue"></div>
          <h2 className="text-3xl font-bold text-black mb-6">About Me</h2>
          <p className="text-gray-700 text-lg leading-relaxed max-w-3xl mx-auto mb-6">
            I'm the oldest of five boys, a dog dad, and new husband trying to build a life for my wife and me.
          </p>
          <div className="flex flex-wrap justify-center items-center gap-3 mb-6">
            <h3 className="text-2xl font-bold text-black">Skills</h3>
            {['Figma','JavaScript', 'React', 'Python', 'Node.js', 'Git', 'SQL'].map((tech, index) => {
              const colors = ['#E53935', '#1E88E5', '#FBC02D'];
              const bgColor = colors[index % colors.length];
              return (
                <span 
                  key={tech} 
                  className="px-4 py-2 font-bold border-2 border-black text-white text-sm"
                  style={{ backgroundColor: bgColor }}
                >
                  {tech}
                </span>
              );
            })}
          </div>
          <div className="flex flex-wrap justify-center items-center gap-3">
            <h3 className="text-2xl font-bold text-black">Not-skills</h3>
            {['Fusion', 'Laser-cutting', '3D printing', 'PCB design', 'System Integration'].map((tech, index) => {
              const colors = ['#E53935', '#1E88E5', '#FBC02D'];
              const bgColor = colors[index % colors.length];
              return (
                <span 
                  key={tech} 
                  className="px-4 py-2 font-bold border-2 border-black text-white text-sm"
                  style={{ backgroundColor: bgColor }}
                >
                  {tech}
                </span>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
